import { createIcon } from '@chakra-ui/icons';

export const LightBulb = createIcon({
  displayName: 'LightBulb',
  viewBox: '0 0 32 33',
  path: [
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_593_2405)">
        <path
          d="M16 21.8477V26.8477V26.3477M16 21.8477L13 18.8477M16 21.8477L19 18.8477"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M16 26.8477C21.5228 26.8477 26 22.3705 26 16.8477C26 11.3249 21.5228 6.84766 16 6.84766C10.4772 6.84766 6 11.3249 6 16.8477C6 22.3705 10.4772 26.8477 16 26.8477Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M11.5 25.8477L12 31.8477H20L20.5 25.8477"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M16 1.84766V2.84766"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M31 16.8477H30"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M2 16.8477H1"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M26.6065 6.24219L25.8994 6.9493"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.10041 6.94929L5.39331 6.24219"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_593_2405">
          <rect width="32" height="32" fill="white" transform="translate(0 0.847656)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
